import axios from 'axios';
import API_ROUTES from '../../routes/ApiRoutes.js';

// Obtener el registro por id
export const getUserById = async (id) => {
    const { data } = await axios.get(`${API_ROUTES.USERS}/${id}`);
    return data;
};
// procedimiento actualizar
export const updateUser = async (id, payload) => {
    const { data } = await axios.put(`${API_ROUTES.USERS}/${id}`, payload);
    return data;
};